import * as Yup from "yup";
import parsePhoneNumber from "libphonenumber-js";
import { StringSchema } from "yup";
import { VALIDATION_ERRORS } from "../../Contract/validation/translations";

Yup.addMethod<StringSchema>(Yup.string, "validatePhoneNumber", function() {
  return this.test(
    "valid-phone-number",
    VALIDATION_ERRORS.INVALID_PHONE_NUMBER,
    value => {
      if (value) {
        const phoneNumber = parsePhoneNumber(value);

        if (phoneNumber) {
          return phoneNumber.isValid();
        }
      }

      return false;
    }
  );
});
